import { ImmHelper } from "@base/util/Immutable";
import { IShoppingListItemHandlerAdditional } from "@biz/definitions/ArticleDefinitions";
import { ArticleFeatureStore } from "@biz/definitions/ArticleFeatureDefinitions";
import { IShoppingList, IShoppingListItem } from "@biz/models/ShoppingListDefinitions";

export const ShoppingItemReducers = {
  setCount(old: IShoppingListItem, count: number): IShoppingListItem {
    if (!old?.count && count > 0) {
      old = {...old, addedSlotTime: Date.now()};
    } else if (count === 0)
      old = {...old, addedSlotTime: 0};

    if ((old.countClientAvailable ?? 0) > count)
      old = ImmHelper.setProperty(old, "countClientAvailable", count)
    old = ImmHelper.setProperty(old, "count", count);
    return old;
  },
  setMul(old: IShoppingListItem, mul: number | undefined): IShoppingListItem {
    return ImmHelper.setProperty(old, "mul", mul);
  },
  setAdditional(old: IShoppingListItem, additional: IShoppingListItemHandlerAdditional): IShoppingListItem {
    if (additional.articleNumber !== undefined)
      old = ImmHelper.setProperty(old, "articleNumber", additional.articleNumber);
    if (additional.mul !== undefined)
      old = ImmHelper.setProperty(old, "mul", additional.mul);
    if (additional.features !== undefined)
      old = ImmHelper.setProperty(old, "features", Object.keys(additional.features).length ? additional.features : undefined);
    if (additional.affiliation !== undefined)
      old = ImmHelper.setProperty(old, "affiliation", Object.keys(additional.affiliation).length ? additional.affiliation : undefined);
    return old;
  },
  setArticleNumber(old: IShoppingListItem, articleNumber: string): IShoppingListItem {
    return ImmHelper.setProperty(old, "articleNumber", articleNumber);
  },
  setClientAvailable(old: IShoppingListItem, countClientAvailable: number): IShoppingListItem {
    return ImmHelper.setProperty(old, "countClientAvailable", countClientAvailable);
  },
  setFeatures(old: IShoppingListItem, features: ArticleFeatureStore): IShoppingListItem {
    return ImmHelper.setProperty(old, "features", features);
  },
  setPowderCoating(old: IShoppingListItem, powderCoatingIndex: number | undefined): IShoppingListItem {
    return ImmHelper.setProperty(old, "powderCoatingIndex", powderCoatingIndex)
  }
}

function get(sl: IShoppingList, id: string): IShoppingListItem {
  return sl.items[id];
}

function getOrCreate(sl: IShoppingList, id: string): IShoppingListItem {
  return get(sl, id) || { count: 0 };
}

export const ShoppingListReducers = {
  setItem(old: IShoppingList, id: string, item: IShoppingListItem): IShoppingList {
    return ImmHelper.setProperty(old, "items", id, item);
  },
  setCount(old: IShoppingList, id: string, count: number, additional: IShoppingListItemHandlerAdditional): IShoppingList {
    let oldItem = getOrCreate(old, id);

    oldItem = ShoppingItemReducers.setCount(oldItem, count);
    oldItem = ShoppingItemReducers.setAdditional(oldItem, additional);

    // also keep 0 to override default count
    return ImmHelper.setProperty(old, "items", id, oldItem);
  },
  moveCount(old: IShoppingList, fromId: string, toId: string, count: number, additional: IShoppingListItemHandlerAdditional): IShoppingList {
    let oldItem = get(old, fromId);
    let newItem = getOrCreate(old, toId);
    const oldSlotTime = oldItem?.addedSlotTime;
    if (oldItem) {
      oldItem = ShoppingItemReducers.setCount(oldItem, 0);
      old = ImmHelper.setProperty(old, "items", fromId, oldItem);
    }
    newItem = ShoppingItemReducers.setCount(newItem, count);
    newItem = ShoppingItemReducers.setAdditional(newItem, additional);
    newItem = ImmHelper.setProperty(newItem, "addedSlotTime", oldSlotTime);
    old = ImmHelper.setProperty(old, "items", toId, newItem);
    return old;
  },
  setClientAvailable(old: IShoppingList, id: string, countClientAvailable: number, additional: IShoppingListItemHandlerAdditional): IShoppingList {
    let oldItem = getOrCreate(old, id);
    oldItem = ShoppingItemReducers.setClientAvailable(oldItem, countClientAvailable);
    oldItem = ShoppingItemReducers.setAdditional(oldItem, additional);
    return ImmHelper.setProperty(old, "items", id, oldItem);
  },
  // setMaxUnits(old: IShoppingList, id: string, maxUnits: number): IShoppingList {
  //   const newItem = ShoppingItemReducers.setMaxUnits(old.items[id], maxUnits);
  //   return ImmHelper.setProperty(old, "items", id, newItem);
  // },
  setPowderCoating(old: IShoppingList, id: string, articleNumber: string, powderCoating: number | undefined): IShoppingList {
    let oldItem = getOrCreate(old, id);

    oldItem = ShoppingItemReducers.setPowderCoating(oldItem, powderCoating);
    oldItem = ShoppingItemReducers.setArticleNumber(oldItem, articleNumber);
    return ImmHelper.setProperty(old, "items", id, oldItem);
  },
}
